import { buildImageUrl } from "src/util";

import css from "./ImageCell.module.scss";

interface ImageCellProps {
  image: string;
}

export const ImageCell = ({ image }: ImageCellProps) => {
  return (
    <img
      width={60}
      height={60}
      src={buildImageUrl(image, { width: 60, height: 60, format: "webp" })}
      alt="product_image"
      className={css.image}
    />
  );
};
